import { Asignatura, Modulo, Ciclo } from '../logic/types';

export const MODULOS_PSICO_2013: Modulo[] = [
  { id: 'mod_psicologico', facultad_id: 'psico', nombre: 'Módulo Psicológico', creditos_minimos: 140, color_hex: '#0099A9' },
  { id: 'mod_metodologico', facultad_id: 'psico', nombre: 'Módulo Metodológico', creditos_minimos: 60, color_hex: '#0284C7' },
  { id: 'mod_articulacion', facultad_id: 'psico', nombre: 'Módulo Articulación de Saberes', creditos_minimos: 50, color_hex: '#0D9488' },
  { id: 'mod_practicas', facultad_id: 'psico', nombre: 'Módulo Prácticas y Proyectos', creditos_minimos: 70, color_hex: '#10B981' },
  { id: 'mod_referencial', facultad_id: 'psico', nombre: 'Módulo Referencial', creditos_minimos: 20, color_hex: '#6366F1' }
];

export const CICLOS_PSICO_2013: Ciclo[] = [
  { id: 'ciclo_inicial', facultad_id: 'psico', nombre: 'Ciclo Inicial', creditos_minimos: 80, orden: 1 },
  { id: 'ciclo_formacion', facultad_id: 'psico', nombre: 'Ciclo de Formación Integral', creditos_minimos: 160, orden: 2 },
  { id: 'ciclo_graduacion', facultad_id: 'psico', nombre: 'Ciclo de Graduación', creditos_minimos: 80, orden: 3 }
];

export interface OpcionesGeneracionPsico {
  idioma?: 'ingles' | 'portugues';
  esPlan1988?: boolean;
}

export function generarMallaPsico2013(opciones: OpcionesGeneracionPsico = {}): Asignatura[] {
  const { idioma = 'ingles', esPlan1988 = false } = opciones;

  const ucosBase: Asignatura[] = [
    // ────────────── SEMESTRE 1 (Ciclo Inicial) ──────────────
    {
      id: 'uco_psico_601',
      plan_id: 'plan_psico_2013',
      nombre: 'Historia de la Psicología',
      codigo: '601',
      semestre_sugerido: 1,
      creditos: 10,
      modulo_id: 'mod_psicologico',
      ciclo_id: 'ciclo_inicial',
      estado: 'no_iniciada',
      obligatoria: true
    },
    {
      id: 'uco_psico_6073',
      plan_id: 'plan_psico_2013',
      nombre: 'Neurobiología de la Mente',
      codigo: '6073',
      semestre_sugerido: 1,
      creditos: 5,
      modulo_id: 'mod_psicologico',
      ciclo_id: 'ciclo_inicial',
      estado: 'no_iniciada',
      obligatoria: true
    },
    {
      id: 'uco_psico_400',
      plan_id: 'plan_psico_2013',
      nombre: 'Fundamentos de la Psicología',
      codigo: '400',
      semestre_sugerido: 1,
      creditos: 5,
      modulo_id: 'mod_psicologico',
      ciclo_id: 'ciclo_inicial',
      estado: esPlan1988 ? 'aprobada' : 'no_iniciada',
      obligatoria: true,
      fecha_aprobacion: esPlan1988 ? new Date().toISOString().split('T')[0] : undefined
    },
    {
      id: 'uco_psico_603',
      plan_id: 'plan_psico_2013',
      nombre: 'Epistemología',
      codigo: '603',
      semestre_sugerido: 1,
      creditos: 5,
      modulo_id: 'mod_metodologico',
      ciclo_id: 'ciclo_inicial',
      estado: 'no_iniciada',
      obligatoria: true
    },
    {
      id: 'uco_psico_602',
      plan_id: 'plan_psico_2013',
      nombre: 'Herramientas para el Trabajo Intelectual',
      codigo: '602',
      semestre_sugerido: 1,
      creditos: 5,
      modulo_id: 'mod_metodologico',
      ciclo_id: 'ciclo_inicial',
      estado: 'no_iniciada',
      obligatoria: true
    },
    {
      id: 'uco_psico_607',
      plan_id: 'plan_psico_2013',
      nombre: 'Inicio a la Formación en Psicología (Referencial I)',
      codigo: '607',
      semestre_sugerido: 1,
      creditos: 5,
      modulo_id: 'mod_referencial',
      ciclo_id: 'ciclo_inicial',
      estado: 'no_iniciada',
      obligatoria: true
    },
    {
      id: 'uco_psico_604',
      plan_id: 'plan_psico_2013',
      nombre: 'Articulación de Saberes I',
      codigo: '604',
      semestre_sugerido: 1,
      creditos: 5,
      modulo_id: 'mod_articulacion',
      ciclo_id: 'ciclo_inicial',
      estado: 'no_iniciada',
      obligatoria: true
    },

    // ────────────── SEMESTRE 2 (Ciclo Inicial) ──────────────
    {
      id: 'uco_psico_606',
      plan_id: 'plan_psico_2013',
      nombre: 'Psicología del Desarrollo',
      codigo: '606',
      semestre_sugerido: 2,
      creditos: 10,
      modulo_id: 'mod_psicologico',
      ciclo_id: 'ciclo_inicial',
      estado: 'no_iniciada',
      obligatoria: true,
      requisitos: [[{ tipo: 'curso_aprobado', id: 'uco_psico_601' }]]
    },
    {
      id: 'uco_psico_401',
      plan_id: 'plan_psico_2013',
      nombre: 'Teorías Psicológicas',
      codigo: '401',
      semestre_sugerido: 2,
      creditos: 5,
      modulo_id: 'mod_psicologico',
      ciclo_id: 'ciclo_inicial',
      estado: esPlan1988 ? 'aprobada' : 'no_iniciada',
      obligatoria: true,
      requisitos: [[{ tipo: 'curso_aprobado', id: 'uco_psico_400' }]],
      fecha_aprobacion: esPlan1988 ? new Date().toISOString().split('T')[0] : undefined
    },
    {
      id: 'uco_psico_608',
      plan_id: 'plan_psico_2013',
      nombre: 'Metodología General de la Investigación',
      codigo: '608',
      semestre_sugerido: 2,
      creditos: 5,
      modulo_id: 'mod_metodologico',
      ciclo_id: 'ciclo_inicial',
      estado: 'no_iniciada',
      obligatoria: true,
      requisitos: [[{ tipo: 'curso_aprobado', id: 'uco_psico_603' }]]
    },
    {
      id: 'uco_psico_609',
      plan_id: 'plan_psico_2013',
      nombre: 'Métodos y Herramientas Orientadas a la Extensión',
      codigo: '609',
      semestre_sugerido: 2,
      creditos: 2,
      modulo_id: 'mod_metodologico',
      ciclo_id: 'ciclo_inicial',
      estado: 'no_iniciada',
      obligatoria: true
    },
    {
      id: 'uco_psico_616',
      plan_id: 'plan_psico_2013',
      nombre: 'Entrevista Psicológica',
      codigo: '616',
      semestre_sugerido: 2,
      creditos: 5,
      modulo_id: 'mod_practicas',
      ciclo_id: 'ciclo_inicial',
      estado: 'no_iniciada',
      obligatoria: true
    },
    {
      id: 'uco_psico_610',
      plan_id: 'plan_psico_2013',
      nombre: 'Articulación de Saberes II',
      codigo: '610',
      semestre_sugerido: 2,
      creditos: 5,
      modulo_id: 'mod_articulacion',
      ciclo_id: 'ciclo_inicial',
      estado: 'no_iniciada',
      obligatoria: true,
      requisitos: [[{ tipo: 'curso_aprobado', id: 'uco_psico_604' }]]
    },
    {
      id: 'uco_psico_611',
      plan_id: 'plan_psico_2013',
      nombre: 'Formación Integral (Referencial II)',
      codigo: '611',
      semestre_sugerido: 2,
      creditos: 5,
      modulo_id: 'mod_referencial',
      ciclo_id: 'ciclo_inicial',
      estado: 'no_iniciada',
      obligatoria: true,
      requisitos: [[{ tipo: 'curso_aprobado', id: 'uco_psico_607' }]]
    },
    {
      id: 'uco_psico_transversal_init',
      plan_id: 'plan_psico_2013',
      nombre: 'Cooperación Institucional u Optativa',
      codigo: '600_OPT',
      semestre_sugerido: 2,
      creditos: 5,
      modulo_id: 'mod_referencial',
      ciclo_id: 'ciclo_inicial',
      estado: 'no_iniciada',
      es_opcional: true,
      obligatoria: false
    },
    {
      id: 'uco_psico_idioma',
      plan_id: 'plan_psico_2013',
      nombre: idioma === 'portugues' ? 'Idioma: Portugués Técnico' : 'Idioma: Inglés Técnico',
      codigo: idioma === 'portugues' ? '644G' : '643G',
      semestre_sugerido: 2,
      creditos: 5,
      modulo_id: 'mod_referencial',
      ciclo_id: 'ciclo_inicial',
      estado: 'no_iniciada',
      obligatoria: true
    },

    // ────────────── SEMESTRE 3 (Ciclo Formativo Integral) ──────────────
    {
      id: 'uco_psico_612',
      plan_id: 'plan_psico_2013',
      nombre: 'Psicología Social',
      codigo: '612',
      semestre_sugerido: 3,
      creditos: 10,
      modulo_id: 'mod_psicologico',
      ciclo_id: 'ciclo_formacion',
      estado: 'no_iniciada',
      obligatoria: true,
      requisitos: [[{ tipo: 'creditos_minimos_ciclo', ciclo_id: 'ciclo_inicial', minimo: 40 }]]
    },
    {
      id: 'uco_psico_613',
      plan_id: 'plan_psico_2013',
      nombre: 'Psicología, Sujeto y Aprendizaje',
      codigo: '613',
      semestre_sugerido: 3,
      creditos: 5,
      modulo_id: 'mod_psicologico',
      ciclo_id: 'ciclo_formacion',
      estado: 'no_iniciada',
      obligatoria: true,
      requisitos: [[{ tipo: 'curso_aprobado', id: 'uco_psico_606' }]]
    },
    {
      id: 'uco_psico_621',
      plan_id: 'plan_psico_2013',
      nombre: 'Métodos y Técnicas Cualitativas',
      codigo: '621',
      semestre_sugerido: 3,
      creditos: 5,
      modulo_id: 'mod_metodologico',
      ciclo_id: 'ciclo_formacion',
      estado: 'no_iniciada',
      obligatoria: true,
      requisitos: [[{ tipo: 'curso_aprobado', id: 'uco_psico_608' }]]
    },
    {
      id: 'uco_psico_615',
      plan_id: 'plan_psico_2013',
      nombre: 'Ética y Deontología',
      codigo: '615',
      semestre_sugerido: 3,
      creditos: 3,
      modulo_id: 'mod_referencial',
      ciclo_id: 'ciclo_formacion',
      estado: 'no_iniciada',
      obligatoria: true,
      requisitos: [[{ tipo: 'creditos_minimos_ciclo', ciclo_id: 'ciclo_inicial', minimo: 40 }]]
    },
    {
      id: 'uco_psico_617',
      plan_id: 'plan_psico_2013',
      nombre: 'Articulación de Saberes III',
      codigo: '617',
      semestre_sugerido: 3,
      creditos: 5,
      modulo_id: 'mod_articulacion',
      ciclo_id: 'ciclo_formacion',
      estado: 'no_iniciada',
      obligatoria: true,
      requisitos: [[{ tipo: 'curso_aprobado', id: 'uco_psico_610' }]]
    },

    // ────────────── SEMESTRE 4 (Ciclo Formativo Integral) ──────────────
    {
      id: 'uco_psico_6261',
      plan_id: 'plan_psico_2013',
      nombre: 'Clínica I: Fundamentos Psicoanalíticos',
      codigo: '6261',
      semestre_sugerido: 4,
      creditos: 5,
      modulo_id: 'mod_psicologico',
      ciclo_id: 'ciclo_formacion',
      estado: 'no_iniciada',
      obligatoria: true,
      requisitos: [[{ tipo: 'curso_aprobado', id: 'uco_psico_401' }]]
    },
    {
      id: 'uco_psico_6071',
      plan_id: 'plan_psico_2013',
      nombre: 'Procesos Cognitivos',
      codigo: '6071',
      semestre_sugerido: 4,
      creditos: 5,
      modulo_id: 'mod_psicologico',
      ciclo_id: 'ciclo_formacion',
      estado: 'no_iniciada',
      obligatoria: true,
      requisitos: [[{ tipo: 'curso_aprobado', id: 'uco_psico_6073' }]]
    },
    {
      id: 'uco_psico_620',
      plan_id: 'plan_psico_2013',
      nombre: 'Psicología y Salud',
      codigo: '620',
      semestre_sugerido: 4,
      creditos: 5,
      modulo_id: 'mod_psicologico',
      ciclo_id: 'ciclo_formacion',
      estado: 'no_iniciada',
      obligatoria: true,
      requisitos: [[{ tipo: 'curso_aprobado', id: 'uco_psico_612' }]]
    },
    {
      id: 'uco_psico_614',
      plan_id: 'plan_psico_2013',
      nombre: 'Métodos y Técnicas Cuantitativas',
      codigo: '614',
      semestre_sugerido: 4,
      creditos: 5,
      modulo_id: 'mod_metodologico',
      ciclo_id: 'ciclo_formacion',
      estado: 'no_iniciada',
      obligatoria: true,
      requisitos: [[{ tipo: 'curso_aprobado', id: 'uco_psico_608' }]]
    },
    {
      id: 'uco_psico_650',
      plan_id: 'plan_psico_2013',
      nombre: 'Herramientas de la Psicología Clínica',
      codigo: '650',
      semestre_sugerido: 4,
      creditos: 5,
      modulo_id: 'mod_metodologico',
      ciclo_id: 'ciclo_formacion',
      estado: 'no_iniciada',
      obligatoria: true,
      requisitos: [[{ tipo: 'curso_aprobado', id: 'uco_psico_616' }]]
    },
    {
      id: 'uco_psico_652',
      plan_id: 'plan_psico_2013',
      nombre: 'Herramientas de la Psicología Social',
      codigo: '652',
      semestre_sugerido: 4,
      creditos: 5,
      modulo_id: 'mod_metodologico',
      ciclo_id: 'ciclo_formacion',
      estado: 'no_iniciada',
      obligatoria: true,
      requisitos: [[{ tipo: 'curso_aprobado', id: 'uco_psico_612' }]]
    },
    {
      id: 'uco_psico_624',
      plan_id: 'plan_psico_2013',
      nombre: 'Articulación de Saberes IV',
      codigo: '624',
      semestre_sugerido: 4,
      creditos: 5,
      modulo_id: 'mod_articulacion',
      ciclo_id: 'ciclo_formacion',
      estado: 'no_iniciada',
      obligatoria: true,
      requisitos: [[{ tipo: 'curso_aprobado', id: 'uco_psico_617' }]]
    },

    // ────────────── SEMESTRE 5 (Ciclo Formativo Integral) ──────────────
    {
      id: 'uco_psico_619PI',
      plan_id: 'plan_psico_2013',
      nombre: 'Psicopatología de la Infancia y la Adolescencia',
      codigo: '619PI',
      semestre_sugerido: 5,
      creditos: 5,
      modulo_id: 'mod_psicologico',
      ciclo_id: 'ciclo_formacion',
      estado: 'no_iniciada',
      obligatoria: true,
      requisitos: [[{ tipo: 'curso_aprobado', id: 'uco_psico_606' }]]
    },
    {
      id: 'uco_psico_619PA',
      plan_id: 'plan_psico_2013',
      nombre: 'Psicopatología de Adultos',
      codigo: '619PA',
      semestre_sugerido: 5,
      creditos: 5,
      modulo_id: 'mod_psicologico',
      ciclo_id: 'ciclo_formacion',
      estado: 'no_iniciada',
      obligatoria: true,
      requisitos: [[{ tipo: 'curso_aprobado', id: 'uco_psico_6261' }]]
    },
    {
      id: 'uco_psico_625',
      plan_id: 'plan_psico_2013',
      nombre: 'Neuropsicología',
      codigo: '625',
      semestre_sugerido: 5,
      creditos: 5,
      modulo_id: 'mod_psicologico',
      ciclo_id: 'ciclo_formacion',
      estado: 'no_iniciada',
      obligatoria: true,
      requisitos: [[{ tipo: 'curso_aprobado', id: 'uco_psico_6071' }]]
    },
    {
      id: 'uco_psico_623',
      plan_id: 'plan_psico_2013',
      nombre: 'Diseño de Proyectos',
      codigo: '623',
      semestre_sugerido: 5,
      creditos: 5,
      modulo_id: 'mod_practicas',
      ciclo_id: 'ciclo_formacion',
      estado: 'no_iniciada',
      obligatoria: true,
      requisitos: [[{ tipo: 'curso_aprobado', id: 'uco_psico_621' }]]
    },
    {
      id: 'uco_psico_653',
      plan_id: 'plan_psico_2013',
      nombre: 'Articulación de Saberes V',
      codigo: '653',
      semestre_sugerido: 5,
      creditos: 5,
      modulo_id: 'mod_articulacion',
      ciclo_id: 'ciclo_formacion',
      estado: 'no_iniciada',
      obligatoria: true,
      requisitos: [[{ tipo: 'curso_aprobado', id: 'uco_psico_624' }]]
    },
    {
      id: 'uco_psico_618',
      plan_id: 'plan_psico_2013',
      nombre: 'Construcción de Itinerario (Referencial III)',
      codigo: '618',
      semestre_sugerido: 5,
      creditos: 5,
      modulo_id: 'mod_referencial',
      ciclo_id: 'ciclo_formacion',
      estado: 'no_iniciada',
      obligatoria: true,
      requisitos: [[{ tipo: 'curso_aprobado', id: 'uco_psico_611' }]]
    },

    // ────────────── SEMESTRE 6 (Ciclo Formativo Integral) ──────────────
    {
      id: 'uco_psico_626',
      plan_id: 'plan_psico_2013',
      nombre: 'Problemáticas Contemporáneas de la Psicología Social',
      codigo: '626',
      semestre_sugerido: 6,
      creditos: 5,
      modulo_id: 'mod_psicologico',
      ciclo_id: 'ciclo_formacion',
      estado: 'no_iniciada',
      obligatoria: true,
      requisitos: [[{ tipo: 'curso_aprobado', id: 'uco_psico_612' }]]
    },
    {
      id: 'uco_psico_662A',
      plan_id: 'plan_psico_2013',
      nombre: 'Clínica II: Teorías y Técnicas de las Intervenciones',
      codigo: '662A',
      semestre_sugerido: 6,
      creditos: 5,
      modulo_id: 'mod_psicologico',
      ciclo_id: 'ciclo_formacion',
      estado: 'no_iniciada',
      obligatoria: true,
      requisitos: [[{ tipo: 'curso_aprobado', id: 'uco_psico_6261' }]]
    },
    {
      id: 'uco_psico_645',
      plan_id: 'plan_psico_2013',
      nombre: 'Dispositivos Psicoterapéuticos',
      codigo: '645',
      semestre_sugerido: 6,
      creditos: 5,
      modulo_id: 'mod_psicologico',
      ciclo_id: 'ciclo_formacion',
      estado: 'no_iniciada',
      obligatoria: true,
      requisitos: [[{ tipo: 'curso_aprobado', id: 'uco_psico_619PA' }]]
    },
    {
      id: 'uco_psico_641',
      plan_id: 'plan_psico_2013',
      nombre: 'Psicología y Educación',
      codigo: '641',
      semestre_sugerido: 6,
      creditos: 5,
      modulo_id: 'mod_psicologico',
      ciclo_id: 'ciclo_formacion',
      estado: 'no_iniciada',
      obligatoria: true,
      requisitos: [[{ tipo: 'curso_aprobado', id: 'uco_psico_613' }]]
    },
    {
      id: 'uco_psico_646',
      plan_id: 'plan_psico_2013',
      nombre: 'Articulación de Saberes VI',
      codigo: '646',
      semestre_sugerido: 6,
      creditos: 5,
      modulo_id: 'mod_articulacion',
      ciclo_id: 'ciclo_formacion',
      estado: 'no_iniciada',
      obligatoria: true,
      requisitos: [[{ tipo: 'curso_aprobado', id: 'uco_psico_653' }]]
    },
    {
      id: 'uco_psico_YI',
      plan_id: 'plan_psico_2013',
      nombre: 'Proyecto de Formación Integral',
      codigo: 'YI',
      semestre_sugerido: 6,
      creditos: 10,
      modulo_id: 'mod_practicas',
      ciclo_id: 'ciclo_formacion',
      estado: 'no_iniciada',
      obligatoria: true,
      requisitos: [[{ tipo: 'curso_aprobado', id: 'uco_psico_623' }]]
    },
    {
      id: 'uco_psico_PI',
      plan_id: 'plan_psico_2013',
      nombre: 'Práctica de Formación Integral',
      codigo: 'PI',
      semestre_sugerido: 6,
      creditos: 10,
      modulo_id: 'mod_practicas',
      ciclo_id: 'ciclo_formacion',
      estado: 'no_iniciada',
      obligatoria: true,
      requisitos: [[{ tipo: 'curso_aprobado', id: 'uco_psico_623' }]]
    },

    // ────────────── SEMESTRE 7 Y 8 (Ciclo de Graduación) ──────────────
    {
      id: 'uco_psico_635E',
      plan_id: 'plan_psico_2013',
      nombre: 'Referencial de Egreso',
      codigo: '635E',
      semestre_sugerido: 7,
      creditos: 5,
      modulo_id: 'mod_referencial',
      ciclo_id: 'ciclo_graduacion',
      estado: 'no_iniciada',
      obligatoria: true,
      requisitos: [[{ tipo: 'ciclo_completo', ciclo_id: 'ciclo_inicial' }]]
    },
    {
      id: 'uco_psico_PG',
      plan_id: 'plan_psico_2013',
      nombre: 'Prácticas de Graduación',
      codigo: 'PG',
      semestre_sugerido: 7,
      creditos: 20,
      modulo_id: 'mod_practicas',
      ciclo_id: 'ciclo_graduacion',
      estado: 'no_iniciada',
      obligatoria: true,
      requisitos: [
        [{ tipo: 'ciclo_completo', ciclo_id: 'ciclo_inicial' }],
        [{ tipo: 'creditos_minimos_modulo', modulo_id: 'mod_practicas', minimo: 20 }]
      ]
    },
    {
      id: 'uco_psico_YG',
      plan_id: 'plan_psico_2013',
      nombre: 'Proyecto de Graduación',
      codigo: 'YG',
      semestre_sugerido: 8,
      creditos: 10,
      modulo_id: 'mod_practicas',
      ciclo_id: 'ciclo_graduacion',
      estado: 'no_iniciada',
      obligatoria: true,
      requisitos: [[{ tipo: 'curso_aprobado', id: 'uco_psico_YI' }]]
    },
    {
      id: 'uco_psico_634',
      plan_id: 'plan_psico_2013',
      nombre: 'Trabajo Final de Grado (TFG)',
      codigo: '634',
      semestre_sugerido: 8,
      creditos: 40,
      modulo_id: 'mod_psicologico',
      ciclo_id: 'ciclo_graduacion',
      estado: 'no_iniciada',
      obligatoria: true,
      requisitos: [
        [{ tipo: 'ciclo_completo', ciclo_id: 'ciclo_inicial' }],
        [{ tipo: 'creditos_minimos_ciclo', ciclo_id: 'ciclo_formacion', minimo: 140 }]
      ]
    },
    {
      id: 'uco_psico_optativas_bolsa',
      plan_id: 'plan_psico_2013',
      nombre: 'Bolsa de Optativas / Electivas (Graduación)',
      codigo: 'OPT_GRAD',
      semestre_sugerido: 7,
      creditos: 15,
      modulo_id: 'mod_psicologico',
      ciclo_id: 'ciclo_graduacion',
      estado: 'no_iniciada',
      es_opcional: true,
      obligatoria: false
    }
  ];

  return ucosBase;
}
